import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EmployeePolicy } from './policy';
import { AppConfig, AppConfigKeys } from '../app.config';

@Injectable({
    providedIn: 'root',
})
export class PolicyService {
    #http = inject(HttpClient);
    #appConfig = inject(AppConfig);

    #apiUrl = this.#appConfig.get(AppConfigKeys.ApiUrl);

    getEmployeePolicies(): Observable<EmployeePolicy[]> {
        const url: string = this.#apiUrl + 'employee/policies';
        return this.#http.get<EmployeePolicy[]>(url);
    }

    accept(policyId: number): Observable<void> {
        const url: string = this.#apiUrl + 'employee/policies/accept/' + policyId;

        return this.#http.put<void>(url, {});
    }

    reject(policyId: number): Observable<void> {
        const url: string = this.#apiUrl + 'employee/policies/reject/' + policyId;

        return this.#http.put<void>(url, {});
    }
}
